module.exports = __webpack_public_path__ + "resources/img/main09_m.86118e6c5a6335b91658d61a3d80fd4a.png";